export default __webpack_public_path__ + "static/media/about_icon3.d7f04620.svg";